import { v4 } from 'uuid';

/** As the CI is not picking up the @types/node being
 * installed despite correct tsconfig compilerOptions type [node] */
const isJest = typeof process !== 'undefined' && !!process?.env?.VITEST_WORKER_ID;

/**
 * Generates a random UUID, optionally formatted for use as an HTML ID.
 *
 * When `forHtml` is true, the returned UUID will start with 'ox' to ensure
 * it begins with letters, making it a valid HTML ID (which must start with a letter).
 * In Jest testing environments, the raw UUID is returned by default to maintain
 * compatibility with mocked UUIDs.
 *
 * @param forHtml - Whether to format the UUID for HTML ID compatibility.
 *                  Defaults to `!isJest` (true in normal environments, false in Jest).
 * @returns A random UUID string, potentially modified for HTML ID compatibility.
 */
export const randomUUID = (forHtml = !isJest) => {
  const uuid = v4() as string;

  /** Jest may mock uuid to match fixed string , so we won't change that behavior */
  if (!forHtml) {
    return uuid;
  }

  /** HTML ID is only valid if it starts with letter [a-z] */
  return `ox${uuid.substring(2)}`;
};
